<template>
    <div class="md-search-seo template4" :class="{ 'two-columns': inMapList }">
        <module-box
            :fullColumn="fullColumn"
            :topSpacing="topSpacing"
            :btmSpacing="btmSpacing"
            :mobileNoMargin="mobileNoMargin"
            :mobileTopSpacing="mobileTopSpacing"
            :mobileBtmSpacing="mobileBtmSpacing"
            v-if="showModule"
            class="seo-module-box"
        >
            <div class="search-seo-container">
                <div class="search-seo">
                    <div class="content_wrap">
                        <template v-for="(group, index) in nearbyList">
                            <div
                                :key="index"
                                class="group"
                                :class="{ 'two-columns': inMapList }"
                                v-if="group.list.length > 0"
                            >
                                <h2
                                    class="title"
                                    :class="{ 'in-map-list': inMapList }"
                                >
                                    {{ group.title }}
                                </h2>
                                <ul class="content">
                                    <li
                                        v-for="(item, index) in group.list"
                                        :key="item.name + index"
                                        class="item"
                                    >
                                        <a
                                            class="anchor"
                                            :class="{
                                                'in-map-list': inMapList
                                            }"
                                            :href="item.url"
                                            rel="noopener noreferrer"
                                        >{{ item.name }}</a
                                        >
                                    </li>
                                    <li
                                        class="mobile_more"
                                        v-if="
                                            isMobileSize &&
                                                originList[index] &&
                                                originList[index].length > 5
                                        "
                                        @click="mobileToggleMore(index)"
                                    >
                                        <span>
                                            {{
                                                !moreStatusForMobile[index]
                                                    ? $t(
                                                        'md-search-seo.showMore'
                                                    )
                                                    : $t(
                                                        'md-search-seo.showLess'
                                                    )
                                            }}</span
                                        >
                                        <div
                                            class="icon"
                                            :class="{
                                                rotate: moreStatusForMobile[
                                                    index
                                                ]
                                            }"
                                        >
                                            <span
                                                class="iconfont icon-small-down"
                                            ></span>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </template>
                    </div>
                    <div
                        class="action"
                        :class="{ 'in-map-list': inMapList }"
                        v-if="showMoreBtn && !isMobileSize"
                        @click="toggleMore"
                    >
                        <span>{{
                            !moreStatus
                                ? $t('md-search-seo.showMore')
                                : $t('md-search-seo.showLess')
                        }}</span>
                        <div class="icon" :class="{ rotate: moreStatus }">
                            <span
                                class="iconfont icon-small-down"
                                :class="{ 'in-map-list': inMapList }"
                            ></span>
                        </div>
                    </div>
                </div>
            </div>
        </module-box>
    </div>
</template>

<script>
import common from '../index';
export default {
    mixins: [common]
};
</script>

<style lang="scss">
@import '../../../theme/media.scss';
.search-seo-container {
    @include media-min-800 {
        padding-top: 10px;
        padding-bottom: 10px;
    }
}

.md-search-seo {
    .search-seo {
        .content_wrap {
            width: 100%;
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            transition: height 0.3s ease;
        }
        .group {
            width: 33.33%;

            &.two-columns {
                padding: 0 20px;
            }
            @include media-800 {
                /* padding: 20px 0; */
                padding-bottom: 25px;
                &:last-child {
                    padding-bottom: 0;
                }
                width: 100%;
            }
            .title {
                font-size: 16px;
                font-weight: bold;
                color: #4a4a60;
                font-family: var(--mg-title-font);
                &.in-map-list {
                    color: #fff;
                }
            }
            .content {
                padding: 15px 0;
                @include media-800 {
                    padding-top: 10px;
                }
                .item {
                    cursor: pointer;
                    @include media-min-800 {
                        max-width: 200px;
                    }
                    padding: 5px 0;
                    @include media-800 {
                        padding: 4px 0;
                    }
                    .anchor {
                        display: block;
                        width: 100%;
                        white-space: nowrap;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        font-size: 14px;
                        line-height: 16px;
                        font-weight: normal;
                        color: #4a4a60;
                        &.in-map-list {
                            color: #8195bd;
                        }
                        &:hover {
                            color: #4c84ff;
                        }
                    }
                }
            }
        }
        .mobile_more {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            color: #4c84ff;
            font-size: 14px;
            line-height: 16px;
            margin-top: 7px;

            .icon {
                margin-left: 10px;
                transition: transform 0.3s ease;
                &.rotate {
                    transform: rotate(180deg);
                    transform-origin: center center;
                }
                .iconfont {
                    color: #4c84ff;
                    font-size: 14px;
                }
            }
        }
        .action {
            cursor: pointer;
            margin-top: 10px;
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #4c84ff;
            font-size: 14px;
            line-height: 16px;
            &.in-map-list {
                color: #8195bd;
            }
            .icon {
                margin-left: 10px;
                transition: transform 0.3s ease;
                &.rotate {
                    transform: rotate(180deg);
                    transform-origin: center center;
                }
                .iconfont {
                    color: #4c84ff;
                    font-size: 14px;
                    &.in-map-list {
                        color: #8195bd;
                    }
                }
            }
        }
    }
}
</style>
